import { render, staticRenderFns } from "./app-install-or-update-dialog.vue?vue&type=template&id=05c8a562&scoped=true&"
import script from "./app-install-or-update-dialog.vue?vue&type=script&lang=js&"
export * from "./app-install-or-update-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c8a562",
  null
  
)

export default component.exports